<template>
  <conversation
    :collapsable="false"
    is-page="true"
    :status-id="statusId"
  />
</template>

<script src="./conversation-page.js"></script>
